import { PROFIL, REQUEST_PASS_STATUS, REQUEST_PASS_TYPE } from '../../../constants/enum';
import { Checkbox, FormGroup, TextField } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import { DatePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import React, { useEffect, useRef } from 'react';

const StepEngagementValidationContrat = (props) => {
    const {
        refs,
        profil,
        demandePassage,
        handleChangeCheckBox,
        validation,
        setValidation,
        notAbleToChange,
        demandePassageStyle,
        tracingDossier,
        setTracingDossier,
        handleChangeDate,
        validSteps,
        reference,
    } = props;
    const editable = validSteps.step2 && (profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.CLIENT) || notAbleToChange;


    const previousReceptionDate = useRef(tracingDossier.receptionDate);

  useEffect(() => {
    if (tracingDossier.receptionDate !== previousReceptionDate.current) {
      previousReceptionDate.current = tracingDossier.receptionDate;
    }
  }, [tracingDossier.receptionDate]);
    useEffect(() => {
        if (
            profil.profil === PROFIL.CLIENT &&
            !tracingDossier.readAndSignedBy &&
            (
                demandePassage.id_status === REQUEST_PASS_STATUS.NEW ||
                demandePassage.id_status === REQUEST_PASS_STATUS.WAITING_INTERN ||
                demandePassage.id_status === REQUEST_PASS_STATUS.WAITING_CLIENT
            )
        ) {
            setTracingDossier(prev => ({ ...prev, receptionDate: new Date() }));
        }
    }, [profil, tracingDossier.readAndSignedBy, demandePassage.id_status]);

    return (<div ref={(divRef) => refs.current['step-engagement_et_validation_contrat'] = divRef} className='step'>
        <div className='step-content'>
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <h3 className='modal-step-title'>Engagement & validation du dossier</h3>
                <div>
                    <div><label style={{
                        fontSize: '18px', fontWeight: 'bold',
                    }}>Le soussigné certifie sous sa responsabilité :</label></div>
                    <div>
                        <ul>
                            <li style={demandePassageStyle.listItem}>Être en règle, le cas échéant, avec la
                                réglementation générale du transport routier de marchandises ;
                            </li>
                            <li style={demandePassageStyle.listItem}>Avoir connaissance de la réglementation en
                                matière de transport exceptionnel et ne pas y contrevenir ;
                            </li>
                            <li style={demandePassageStyle.listItem}>L'exactitude des renseignements transmis
                                dans la présente demande ;
                            </li>
                            <li style={demandePassageStyle.listItem}>S'engager à respecter les prescriptions
                                figurant dans l'autorisation individuelle qui lui sera délivrée ;
                            </li>
                            <li style={demandePassageStyle.listItem}>Avoir reconnu ou fait reconnaitre
                                l'itinéraire autorisé et notamment les traversées d'agglomération, le
                                franchissement des passages à niveau et des ouvrages d'art ;
                            </li>
                            <li style={demandePassageStyle.listItem}>S'assurer qu'il n'existe pas d'arrêté
                                réglementant la circulation et qui l'empêcherait d'emprunter l'itinéraire ;
                            </li>
                            <li style={demandePassageStyle.listItem}>Effectuer le transport dans le respect des
                                règles de charge ou des limites dérogatoires autorisées, avec des véhicules
                                compatibles entre eux et avec le chargement transporté ;
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='row' style={{
                flexWrap: 'nowrap',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
            }}>
                {profil.profil === PROFIL.CLIENT &&
                    <>
                        {tracingDossier.readAndSignedBy &&
                            <div style={{ fontSize: '16px' }}>Lu et approuvé
                                le <b>{moment(tracingDossier.receptionDate).format('DD/MM/YYYY')}</b> {tracingDossier && <> par <b>{tracingDossier.readAndSignedBy}</b></>}
                            </div>
                        }
                        {!tracingDossier.readAndSignedBy &&
                            <FormGroup style={{ display: 'flex', flexDirection: 'row', alignContent: 'center' }}>
                                {(demandePassage.id_status === REQUEST_PASS_STATUS.NEW || demandePassage.id_status === REQUEST_PASS_STATUS.WAITING_INTERN || demandePassage.id_status === REQUEST_PASS_STATUS.WAITING_CLIENT) &&
                                    <>
                                        <FormControlLabel
                                            label='Lu et approuvé le '
                                            control={<Checkbox name='isValidStep'
                                                               style={{ padding: '10px' }}
                                                               onChange={(e) => handleChangeCheckBox(e, validation, setValidation)}
                                                               value={validation}
                                                               disabled={editable} />
                                            }
                                        />
                                        <DatePicker
                                            name='receptionDate'
                                            value={tracingDossier.receptionDate}
                                            style={demandePassageStyle.textField}
                                            onChange={(newValue) => handleChangeDate(tracingDossier, setTracingDossier, 'receptionDate', newValue)}
                                            renderInput={(params) => <TextField {...params} />}
                                            inputVariant='outlined'
                                            disabled={true}
                                            minDate={new Date()}
                                        />
                                    </>
                                }
                                {demandePassage.id_status !== REQUEST_PASS_STATUS.NEW && demandePassage.id_status !== REQUEST_PASS_STATUS.WAITING_INTERN && demandePassage.id_status !== REQUEST_PASS_STATUS.WAITING_CLIENT &&
                                    <>
                                        <FormControlLabel
                                            label='Lu et approuvé le '
                                            control={<Checkbox name='isValidStep'
                                                               style={{ padding: '10px' }}
                                                               checked={true}
                                                               value={validation}
                                                               disabled={editable} />
                                            }
                                        />
                                        <DatePicker
                                            name='receptionDate'
                                            value={tracingDossier.receptionDate}
                                            style={demandePassageStyle.textField}
                                            onChange={(newValue) => handleChangeDate(tracingDossier, setTracingDossier, 'receptionDate', newValue)}
                                            renderInput={(params) => <TextField {...params} />}
                                            inputVariant='outlined'
                                            disabled={editable}
                                            minDate={new Date()}
                                        />
                                    </>
                                }
                            </FormGroup>
                        }
                    </>
                }
                {
                    (profil.profil < 5) &&
                    <>
                        {tracingDossier.readAndSignedBy &&
                            <div style={{ fontSize: '16px' }}>Lu et approuvé
                                le <b>{moment(tracingDossier.receptionDate).format('DD/MM/YYYY')}</b> {tracingDossier && <> par <b>{tracingDossier.readAndSignedBy}</b></>}
                            </div>
                        }
                        {!tracingDossier.readAndSignedBy &&
                            <FormGroup style={{ display: 'flex', flexDirection: 'row', alignContent: 'center' }}>
                                {(demandePassage.id_status === REQUEST_PASS_STATUS.NEW || demandePassage.id_status === REQUEST_PASS_STATUS.WAITING_INTERN || demandePassage.id_status === REQUEST_PASS_STATUS.WAITING_CLIENT) &&
                                    <FormControlLabel
                                        label='Lu et approuvé le '
                                        control={<Checkbox name='isValidStep'
                                                           style={{ padding: '10px' }}
                                                           onChange={(e) => handleChangeCheckBox(e, validation, setValidation)}
                                                           value={validation}
                                                           disabled={editable} />
                                        }
                                    />
                                }
                                <DatePicker
                                    name='receptionDate'
                                    value={tracingDossier.receptionDate}
                                    style={demandePassageStyle.textField}
                                    onChange={(newValue) => handleChangeDate(tracingDossier, setTracingDossier, 'receptionDate', newValue)}
                                    renderInput={(params) => <TextField {...params} />}
                                    inputVariant='outlined'
                                    disabled={editable}
                                    minDate={profil.profil === PROFIL.ADMINISTRATEUR ? '' : new Date()}
                                />
                            </FormGroup>
                        }
                    </>
                }
            </div>
        </div>
    </div>);
};

export default StepEngagementValidationContrat;